import { optimizelyFeatureDecision } from 'store/ui/uiActions';
import { createOptimizelyFeatureDecisionEvent, createHotelsOptimizelyFeatureDecisionEventPayload } from '@qantasexperiences/analytics';

const emitOptimizelyFeatureDecisionEvent = ({ payload }) => {
  const optimizelyFeatureDecisionEvent = createOptimizelyFeatureDecisionEvent(
    createHotelsOptimizelyFeatureDecisionEventPayload({
      flagKey: payload.flagKey,
      variationKey: payload.variationKey,
      ruleKey: payload.ruleKey,
      enabled: payload.enabled,
    }),
  );

  return optimizelyFeatureDecisionEvent;
};

// eslint-disable-next-line
// @ts-ignore
export default { [optimizelyFeatureDecision]: emitOptimizelyFeatureDecisionEvent };
